import { render, staticRenderFns } from "./SamlIdp.vue?vue&type=template&id=1ff90758&scoped=true"
import script from "./SamlIdp.vue?vue&type=script&lang=ts"
export * from "./SamlIdp.vue?vue&type=script&lang=ts"
import style0 from "./SamlIdp.vue?vue&type=style&index=0&id=1ff90758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff90758",
  null
  
)

export default component.exports